{
  "version": 1,
  "asset_id": "660c42ef-cb9f-4483-885f-52b042ef6c73",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/660c42ef-cb9f-4483-885f-52b042ef6c73/sleeve-to-bypass-first-view-en-1200.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/660c42ef-cb9f-4483-885f-52b042ef6c73/sleeve-to-bypass-first-view-en-1200.webp",
  "original_filename": "sleeve-to-bypass-first-view-en-1200.webp",
  "size": 59050,
  "content_type": "image/webp",
  "created_at": "2026-10-05T12:33:53Z"
}
